module.exports = __webpack_public_path__ + "img/16m-sprint.c1eb9f0b.png";